import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { WorkflowForm } from '../../types/generated.types';

@Injectable({ providedIn: 'root' })
export class WorkflowFormsApiService extends BaseApiService {
  protected get baseUrl(): string {
    return `${super.baseUrl}/workflow-forms`;
  }

  async getWorkflowForms(): Promise<WorkflowForm[]> {
    return await this.get<WorkflowForm[]>('');
  }

  async getWorkflowForm(id: string): Promise<WorkflowForm> {
    return await this.get<WorkflowForm>(id);
  }

  async createWorkflowForm(workflowForm: WorkflowForm): Promise<string> {
    return await this.postWithResult<WorkflowForm, string>('', workflowForm);
  }

  async updateWorkflowForm(workflowForm: WorkflowForm): Promise<void> {
    return await this.put('', workflowForm);
  }

  async deleteWorkflowForm(id: string): Promise<void> {
    return await this.delete(`${id}`);
  }
}
